import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DownloadIcon, FolderOpenIcon, CalendarCheckIcon } from 'lucide-react';
const stepVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: i * 0.15,
      ease: 'easeOut'
    }
  })
};
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section className="w-full bg-white py-16 md:py-24" ref={ref} data-id="element-146">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-148">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-navy-900 mb-4" data-id="element-149">
            Cómo funciona
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-150" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-151">
          {/* Step 1 */}
          <motion.div custom={0} variants={stepVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="text-center" data-id="element-152">
            <div className="relative mx-auto w-20 h-20 bg-gold-500/15 rounded-2xl flex items-center justify-center mb-6" data-id="element-153">
              <DownloadIcon className="w-8 h-8 text-gold-600" aria-hidden="true" data-id="element-154" />
              <span className="absolute -top-2 -right-2 w-8 h-8 bg-gold-500 text-navy-900 font-heading font-bold text-sm rounded-full flex items-center justify-center" data-id="element-155">
                1
              </span>
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-3" data-id="element-156">
              Descarga e Imprime
            </h3>
            <p className="font-body text-gray-600 leading-relaxed" data-id="element-157">
              Obtén el protocolo y los checklists de inmediato en tu correo.
              Todo listo para imprimir o usar en tu tablet.
            </p>
          </motion.div>

          {/* Step 2 */}
          <motion.div custom={1} variants={stepVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="text-center" data-id="element-158">
            <div className="relative mx-auto w-20 h-20 bg-gold-500/15 rounded-2xl flex items-center justify-center mb-6" data-id="element-159">
              <FolderOpenIcon className="w-8 h-8 text-gold-600" aria-hidden="true" data-id="element-160" />
              <span className="absolute -top-2 -right-2 w-8 h-8 bg-gold-500 text-navy-900 font-heading font-bold text-sm rounded-full flex items-center justify-center" data-id="element-161">
                2
              </span>
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-3" data-id="element-162">
              Prepara tu Carpeta
            </h3>
            <p className="font-body text-gray-600 leading-relaxed" data-id="element-163">
              Organiza tus documentos de origen siguiendo nuestra lista de
              validación antes de subirte al avión.
            </p>
          </motion.div>

          {/* Step 3 */}
          <motion.div custom={2} variants={stepVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="text-center" data-id="element-164">
            <div className="relative mx-auto w-20 h-20 bg-gold-500/15 rounded-2xl flex items-center justify-center mb-6" data-id="element-165">
              <CalendarCheckIcon className="w-8 h-8 text-gold-600" aria-hidden="true" data-id="element-166" />
              <span className="absolute -top-2 -right-2 w-8 h-8 bg-gold-500 text-navy-900 font-heading font-bold text-sm rounded-full flex items-center justify-center" data-id="element-167">
                3
              </span>
            </div>
            <h3 className="font-heading text-xl font-bold text-navy-900 mb-3" data-id="element-168">
              Ejecuta el Plan
            </h3>
            <p className="font-body text-gray-600 leading-relaxed" data-id="element-169">
              Sigue el calendario día por día desde que aterrizas hasta que tus
              hijos entran a su nueva escuela.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}